import * as React from 'react';
import { graphql } from 'gatsby';

import Seo from '../components/seo';
import Literature from '../components/pages/literature';

const LiteraturePage = ({ data, location }) => {
  const title = 'Literature';
  const products = data.allWpProduct?.nodes || [];
  const productsGroupedByCategories = groupProductsByCategories(products);

  const tabPages = data.allWpPage?.nodes?.map(node => ({
    title: node.title,
    slug: node.slug,
    content: node.content,
  accordionItems: node.accordionItems?.relationship?.map(accordion => ({
      title: accordion.title,
      content: accordion.content
    }))
  }));

  // Add a fake datasheets tab at index 2
  tabPages.splice(2, 0, {
    title: 'Datasheets',
    slug: 'datasheets',
    datasheetDetails: {
      productsGroupedByCategories
    }
  });

  return (
    <div>
      <Seo title={title} />
      {/* TODO: Fix ordering to get rid of the .reverse() & change the fake datasheest tab index back to 1 */}
      <Literature tabPages={tabPages.reverse()} productsGroupedByCategories={productsGroupedByCategories} location={location} />
    </div>
  )
};

export default LiteraturePage;

function groupProductsByCategories(products) {
  return products.reduce(function (acc, obj) {
    const key = obj.categories?.nodes?.map(_ => _.name) || 'Data Missing';
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});
}

export const pageQuery = graphql`
  query LiteraturePageQuery {
    allWpPage(filter: { wpParent: { node: { slug: { eq: "literature" } } } } ) {
      nodes {
        title
        slug
        content
        accordionItems {
          relationship {
            ... on WpAccordionItem {
              title
              content
            }
          }
        }
      }
    }

    allWpProduct {
      nodes {
        title
        productDetails {
          datasheet {
            mediaItemUrl
          }
        }
        categories {
          nodes {
            slug
            name
          }
        }
      }
    }
  }
`;
